/**
 * Le tableau vide qui ne change pas d'une image à l'autre.
 *
 * `data?.fournisseurs ?? []` a l'air inoffensif, et il l'est presque : quand
 * la requête n'a pas encore répondu, il fabrique un tableau **neuf à chaque
 * rendu**. Toute mémoïsation qui en dépend s'invalide donc à chaque fois, et
 * le `useMemo` qui devait épargner un tri le refait sans arrêt.
 *
 * Ce n'est pas une panne — l'écran affiche ce qu'il doit — c'est du travail
 * refait pour rien, et un outillage qui ne peut plus distinguer le vrai
 * défaut du faux. D'où cette constante : la même référence pour tout le
 * monde, à chaque rendu.
 *
 *     const fournisseurs = data?.fournisseurs ?? vide<Fournisseur>();
 *
 * Le typage passe par une fonction plutôt qu'une constante nue : un
 * `readonly never[]` ne s'affecte pas à un `Fournisseur[]` sans transtypage,
 * et l'on ne veut pas d'un transtypage à chaque appel.
 */

const AUCUN: readonly never[] = Object.freeze([]);

/** Un tableau vide partagé, typé pour le contexte qui l'appelle. */
export function vide<T>(): T[] {
  return AUCUN as unknown as T[];
}
